'use strict';

/* jshint -W098 */
angular.module('mean.system-lots').controller('SystemLotsController', ['$scope', 'Global', 'Projects', 'MeanUser', 'Users', '$filter', 'SystemLots', 'Trades', 'toaster', 'builderService', 'Builders', '$q', 'userService', 'invoiceNumberService', 'createInvoiceService', 'taskService',
  function($scope, Global, Projects, MeanUser, Users, $filter, SystemLots, Trades, toaster, builderService, Builders, $q, userService, invoiceNumberService, createInvoiceService, taskService) {
    $scope.global = Global;
    $scope.package = {
      name: 'system-lots'
    };

    $scope.user = MeanUser.user;
    $scope.projects = [];
    $scope.systemLots = [];
    $scope.display_projects = [];
    $scope.showExpandableDetails = -1;
    $scope.userMadeDateSelection = false;

    $scope.my_roles = MeanUser.user.roles;

    $scope.invoice_date = moment();
    $scope.due_date = moment().add(14, 'days');

    $scope.init = function() {
        Users.query({'type': 'SystemUsersOnly'}, function(users) {
          $scope.users = users;
        });
    };

    $scope.getCompanyData  = function() {
        var deferred = $q.defer();

        if(builderService.isBuilder($scope.selectedUser.username)) {
            Builders.query({'builder': $scope.selectedUser._id}, function(builders) {
                if(builders.length === 0) {
                    toaster.pop('error', 'Builders DB Entry', 
                        'Could not find a Builder Entry for selected user.  Contact Admin');
                    return;
                } else if(builders.length > 1) {
                    toaster.pop('error', 'Builders DB Entry', 
                        'Too many Builder entries.  Contact Admin');
                    return;
                }
                builders[0].company_code = userService.getCompanyCode($scope.selectedUser.username);
                builders[0].trade_code = userService.getTradeCode($scope.selectedUser.username);
                deferred.resolve(builders[0]);
            });
        } else {
            Trades.query({'main_account_id': $scope.selectedUser._id}, function(trades) {
                if(trades.length === 0) {
                    toaster.pop('error', 'Trades DB Entry', 
                        'Could not find a Trade Entry for selected user.  Contact Admin');
                    return;
                } else if(trades.length > 1) {
                    toaster.pop('error', 'Trades DB Entry', 
                        'Too many Trade entries.  Contact Admin');
                    return;
                }
                trades[0].company_code = userService.getCompanyCode($scope.selectedUser.username);
                trades[0].trade_code = userService.getTradeCode($scope.selectedUser.username);
                deferred.resolve(trades[0]);
            });
        }

        return deferred.promise;
    };

    $scope.changeUser = function() {
        $scope.getCompanyData().then(function(data) {
            var addr_one = data.address_one;
            var addr_two = data.city + ', ' + data.state + ' ' + data.zip;
            $scope.originalUserData = data;
            $scope.selectedUser.address_one = addr_one;
            $scope.selectedUser.address_two = addr_two;
            $scope.selectedUser.company_email = data.email;
            $scope.selectedUser.company_phone = data.phone;
            $scope.selectedUser.company_name = data.name;
            $scope.selectedUser.per_task_price = data.per_task_price;
            $scope.selectedUser.per_t_and_m_price = data.per_t_and_m_price;
            $scope.selectedUser.service_price = data.service_price;
            $scope.selectedUser.multi_per_task_price = data.multi_per_task_price;
            $scope.selectedUser.multi_per_t_and_m_price = data.multi_per_t_and_m_price;
            $scope.selectedUser.trade_code = data.trade_code;
            $scope.selectedUser.company_code = data.company_code;

            Projects.query({'trade_code': data.trade_code, 
                'company_code': data.company_code}, function(projects) {
                $scope.projects = projects;
                SystemLots.query({'trade_code': data.trade_code, 
                    'company_code': data.company_code}, function(systemLots) {
                    $scope.systemLots = systemLots;
                    if($scope.userMadeDateSelection) {
                        $scope.dateRangeUpdated();
                    }
                });
            });
        });
    };

    $scope.editPerTaskTotal = function(item) {
        item.perTaskTotalEditing = true;
    };

    $scope.editTMPerTask = function(item) {
        item.tmPerTaskEditing = true;
    };

    $scope.editStandardService = function(item) {
        item.standardServiceEditing = true;
    };

    $scope.editMultiplePerTaskTotal = function(item) {
        item.perMultipleTaskTotalEditing = true;
    };

    $scope.editTMMultiplePerTask = function(item) {
        item.tmMultiplePerTaskEditing = true;
    };

    $scope.updateAccount = function() {
        $scope.originalUserData.per_task_price = $scope.selectedUser.per_task_price;
        $scope.originalUserData.per_t_and_m_price = $scope.selectedUser.per_t_and_m_price;
        $scope.originalUserData.service_price = $scope.selectedUser.service_price;
        $scope.originalUserData.multi_per_task_price = $scope.selectedUser.multi_per_task_price;
        $scope.originalUserData.multi_per_t_and_m_price = $scope.selectedUser.multi_per_t_and_m_price;
        $scope.originalUserData.$update(function(success) {
            $scope.selectedUser.per_task_price = success.per_task_price;
            $scope.selectedUser.per_t_and_m_price = success.per_t_and_m_price;
            $scope.selectedUser.service_price = success.service_price;
            $scope.selectedUser.multi_per_task_price = success.multi_per_task_price;
            $scope.selectedUser.multi_per_t_and_m_price = success.multi_per_t_and_m_price;

            $scope.selectedUser.perTaskTotalEditing = false;
            $scope.selectedUser.tmPerTaskEditing = false;
            $scope.standardServiceEditing = false;
            $scope.perMultipleTaskTotalEditing = false;
            $scope.tmMultiplePerTaskEditing = false;
            if($scope.userMadeDateSelection)
                $scope.dateRangeUpdated();
            toaster.pop('success', 'Database Updated');
        }, function(error) {
            toaster.pop('error', 'Database Update Error', error);
        });
    };

    $scope.addLotToTotal = function(lotData, systemLot, proj, projLot) {
        var inlist = $filter('filter')($scope.display_projects, {'_id': systemLot.project_id}, true);

        if(inlist.length === 0) {
            lotData.plan = projLot.plan;
            var lastDate = 'N/A';
            if(lotData.rescheduled) {
                lastDate = 
                    moment(lotData.date_rescheduled[lotData.date_rescheduled.length-1]);
            }
            lotData.date_scheduled = moment(lotData.date_scheduled);
            lotData.last_reschedule = lastDate;
            lotData.price = (projLot.plan === 'T&M')?
                $scope.selectedUser.per_t_and_m_price:$scope.selectedUser.per_task_price;
            $scope.display_projects.push({
                '_id': proj._id,
                'project_id': proj._id,
                'name': proj.name,
                'projectType': proj.projectType,
                't_and_m': (projLot.plan === 'T&M')?1:0,
                'number_of_lots': 1,
                'total_cost': lotData.price,
                'lots': [lotData]
            });
        } else if(inlist.length === 1) {
            var lastDate = 'N/A';
            if(lotData.rescheduled) {
                lastDate = 
                    moment(lotData.date_rescheduled[lotData.date_rescheduled.length-1]);
            }
            lotData.date_scheduled = moment(lotData.date_scheduled);
            if(projLot.plan === 'T&M') {
                inlist[0].t_and_m++;
                lotData.price = $scope.selectedUser.per_t_and_m_price;
            } else {
                lotData.price = $scope.selectedUser.per_task_price;
            }
            lotData.plan = projLot.plan;
            lotData.last_reschedule = lastDate;
            inlist[0].total_cost += lotData.price;
            inlist[0].number_of_lots++;
            inlist[0].lots.push(lotData);
        } else {
            toaster.pop('error', 'Project Data Error', 'Contact Admin');
            return;
        }

        $scope.total_lots++;
        $scope.total_cost += lotData.invoice_cost;
    };

    var getProjectTasks = function(projects) {
        var deferred = $q.defer();

        taskService.getProjectTasksForLot(projects).then(function(results) {
            _.each(results, function(result) {
                var proj = $filter('filter')($scope.display_projects, {
                    'project_id': result.project_id, 'projectType': 'Service'}, true);
                if(proj.length == 1) {
                    result.not_charged = false;
                } else if(result.plan_code == 'T&M') {
                    result.not_charged = false;
                } else {
                    result.not_charged = false;
                    if(result.bid_hours == 0 && result.actual_labor_costs == 0 &&
                        result.actual_material_costs == 0 && result.actual_equipment_costs == 0)
                        result.not_charged = true;

                    if(result.company_code != $scope.selectedUser.contractor_code)
                        result.not_charged = true;
                }
            });
            deferred.resolve(results);
        });

        return deferred.promise;
    }

    $scope.dateRangeUpdated = function() {
        if(!$scope.selectedUser) return;
        $scope.userMadeDateSelection = true;

        var startDate = this.reportDateRange.startDate;
        var endDate = this.reportDateRange.endDate;
        $scope.display_projects = [];
        $scope.total_lots = 0;
        $scope.total_cost = 0;

        console.log('dateRageUpdated');

        $scope.invoiced_projects = [];

        _.each($scope.systemLots, function(systemLot) {
            _.each(systemLot.lots, function(lotData) {
                if(lotData.date_scheduled) {
                    var sched = moment(lotData.date_added);
                    var start = moment(lotData.date_scheduled);
                    
                    var compareDate = (sched > start)?sched:start;
                    if(startDate < compareDate && compareDate < endDate) {
                        var proj = $filter('filter')($scope.projects, {'_id': systemLot.project_id}, true);

                        if(proj.length !== 1) {
                            toaster.pop('error', 'Project List Error', 'Contact Admin');
                            return;
                        }

                        var projLotData = {
                            '_id': proj[0]._id,
                            'get_tasks': [{
                                'trade': $scope.selectedUser.trade[0],
                                'phase': lotData.phase,
                                'number': lotData.number
                            }]
                        }

                        //list of projects so we can get the projectTasks later
                        if($scope.invoiced_projects.indexOf(projLotData) == -1)
                            $scope.invoiced_projects.push(projLotData);

                        if(proj[0].lots.length > 0) {
                            var projLot = $filter('filter')(proj[0].lots, { 'number': lotData.number,
                                'phase': lotData.phase }, true);

                            if(projLot.length !== 1) {
                                toaster.pop('warning', 'Project Lot Issue', 'Project ' + 
                                    proj[0].name + ' has ' + projLot.length + ' with the same phase ' +
                                    lotData.phase + ' and lot number ' + lotData.number + 
                                    '.  Adding all to total.');
                                _.each(projLot, function(lot) {
                                    $scope.addLotToTotal(lotData, systemLot, proj[0], lot);
                                });
                            } else {
                                $scope.addLotToTotal(lotData, systemLot, proj[0], projLot[0]);
                            }
                        } else {
                            toaster.pop('warning', 'Project ' + proj[0].name + ' Has No Lots',
                                'There are no lots found for this project.');
                        }
                    }
                } else {
                    var proj = $filter('filter')($scope.projects, {'_id': systemLot.project_id}, true);
                    console.log('Project ' + proj[0].name + ' Lot Not Billed.  ' +
                        'Lot ' + lotData.number + 
                        ' has been added to the system but has not been scheduled yet.');
                }
            });
        });

        $scope.invoice_string = 
        invoiceNumberService.getNext($scope.selectedUser.company_code,
            $scope.selectedUser.trade_code, this.reportDateRange.startDate, 
            this.reportDateRange.endDate).then(function(inv_str) {
                $scope.invoice_string = 'INV-' + $scope.selectedUser.trade_code +
                    $scope.selectedUser.company_code + inv_str;
        });

        $scope.display_projects = $filter('orderBy')($scope.display_projects, 'name');

        //get the ProjectTasks for all of my $scope.invoiced_projects
        getProjectTasks($scope.invoiced_projects).then(function(projectTasks) {
            //console.log(projectTasks);
            console.log('need to add task details for each lot listed and update totals');
            //console.log($scope.display_projects);

            $scope.display_projects.invoice_cost = 0;
            _.each($scope.display_projects, function(project) {
                project.invoice_cost = 0;
                _.each(project.lots, function(lot) {
                    var tasks = _.remove(projectTasks, function(task) {
                        return task.project_id == project._id && task.phase == lot.phase &&
                            task.lot == lot.number
                    });

                    var standard_task_price = $scope.selectedUser.per_task_price;
                    var standard_tm_price = $scope.selectedUser.per_t_and_m_price;
                    if(project.projectType == 'Service') {
                        standard_task_price = $scope.selectedUser.service_price;
                    } else if(project.project_type == 'multi') {
                        standard_task_price = $scope.selectedUser.multi_per_task_price;
                        standard_tm_price = $scope.selectedUser.multi_per_t_and_m_price;
                    }

                    //add to display
                    lot.tasks = tasks;
                    lot.invoice_cost = 0;
                    _.each(lot.tasks, function(item) {
                        if(item.not_charged) {
                            item.invoice_cost = 0;
                        } else {
                            if(item.plan_code == 'T&M')
                                item.invoice_cost = standard_tm_price;
                            else 
                                item.invoice_cost = standard_task_price;
                        }
                        lot.invoice_cost += item.invoice_cost;
                    });
                    project.invoice_cost += lot.invoice_cost;
                });
                $scope.display_projects.invoice_cost += project.invoice_cost;
            });

            console.log($scope.display_projects);
        });
    };

    $scope.setShowExpandableDetails =  function(pid) {
        if($scope.showExpandableDetails === pid)
            $scope.showExpandableDetails = -1;
        else
            $scope.showExpandableDetails = pid;
    };

    $scope.setShowExpandableLots =  function(pid) {
        if($scope.showExpandableLots === pid)
            $scope.showExpandableLots = -1;
        else
            $scope.showExpandableLots = pid;
    };

    $scope.createInvoice = function() {
        //$scope.display_projects.total = $scope.total_cost;
        createInvoiceService.create($scope.selectedUser, 
            $scope.display_projects, $scope.invoice_string,
            this.reportDateRange.startDate, this.reportDateRange.endDate);
    };

    $scope.editDate = function (item) {
        item.dateEditing = true;
        item.originalDate = item.date_scheduled;
    };

    $scope.doneDateEditing = function (item, idx) {
        if(!item.dateEditing) return;
        $scope.cutLot = false;

        var originalMonth = moment(item.originalDate).month();
        var newMonth = moment(item.date_scheduled).month();
        if(originalMonth !== newMonth) {
            $scope.cutLot = true;
        }

        var proj = $filter('filter')($scope.systemLots, {
            'project_id': $scope.display_projects[idx].project_id }, true);

        if(proj.length !== 1) {
            toaster.pop('error', 'Project Error', 'Problem finding the project for the given lot');
            return;
        }

        var lot = $filter('filter')(proj[0].lots, {'number': item.number,
            'phase': item.phase}, true);

        if(lot.length !== 1) {
            toaster.pop('error', 'Project Lot Error', 'Problem finding the lot');
            return;
        }

        lot[0].date_scheduled = new Date(item.date_scheduled);

        proj[0].$update(function(success) {
            var lotIdx = $scope.display_projects[idx].lots.indexOf(lot[0]);
            var lot = $filter('filter')(success.lots, {'number': item.number,
                'phase': item.phase}, true);
            if(lot.length !== 1 || lotIdx === -1) {
                toaster.pop('error', 'Lot Return Error', 'Refresh page to view data.');
            } else {
                $scope.display_projects[idx].lots[lotIdx].date_scheduled = moment(lot[0].date_scheduled);
            }

            if($scope.cutLot) {
                if(lotIdx !== -1) {
                    if($scope.display_projects[idx].lots[lotIdx].plan === 'T&M') {
                        $scope.display_projects[idx].t_and_m--;
                    } 
                    $scope.display_projects[idx].number_of_lots--;
                    $scope.display_projects[idx].total_cost -= 
                        $scope.display_projects[idx].lots[lotIdx].price;

                    $scope.total_cost -= $scope.display_projects[idx].lots[lotIdx].price;

                    $scope.display_projects[idx].lots.splice(lotIdx, 1);
                }
            } 
            toaster.pop('success', 'Date Scheduled Updated');
        }, function(error) {
            toaster.pop('error', 'Date Schedule Error', error);
            item.date_scheduled = item.originalDate;
        });

        item.dateEditing = false;
    };

    $scope.editAddedDate = function (item) {
        item.addedDateEditing = true;
        item.originalDate = item.date_added;
    };

    $scope.doneAddedDateEditing = function (item, idx) {
        if(!item.addedDateEditing) return;
        $scope.cutLot = false;

        var originalMonth = moment(item.originalDate).month();
        var newMonth = moment(item.date_added).month();
        if(originalMonth !== newMonth) {
            //$scope.cutLot = true;
        }

        var proj = $filter('filter')($scope.systemLots, {
            'project_id': $scope.display_projects[idx].project_id }, true);

        if(proj.length !== 1) {
            toaster.pop('error', 'Project Error', 'Problem finding the project for the given lot');
            return;
        }

        var lot = $filter('filter')(proj[0].lots, {'number': item.number,
            'phase': item.phase}, true);

        if(lot.length !== 1) {
            toaster.pop('error', 'Project Lot Error', 'Problem finding the lot');
            return;
        }

        lot[0].date_added = new Date(item.date_added);

        proj[0].$update(function(success) {
            var lotIdx = $scope.display_projects[idx].lots.indexOf(lot[0]);
            var lot = $filter('filter')(success.lots, {'number': item.number,
                'phase': item.phase}, true);
            if(lot.length !== 1 || lotIdx === -1) {
                toaster.pop('error', 'Lot Return Error', 'Refresh page to view data.');
            } else {
                $scope.display_projects[idx].lots[lotIdx].date_added = moment(lot[0].date_added);
            }

            if($scope.cutLot) {
                if(lotIdx !== -1) {
                    if($scope.display_projects[idx].lots[lotIdx].plan === 'T&M') {
                        $scope.display_projects[idx].t_and_m--;
                    } 
                    $scope.display_projects[idx].number_of_lots--;
                    $scope.display_projects[idx].total_cost -= 
                        $scope.display_projects[idx].lots[lotIdx].price;

                    $scope.total_cost -= $scope.display_projects[idx].lots[lotIdx].price;

                    $scope.display_projects[idx].lots.splice(lotIdx, 1);
                }
            } 
            toaster.pop('success', 'Date Scheduled Updated');
        }, function(error) {
            toaster.pop('error', 'Date Schedule Error', error);
            item.date_added = item.originalDate;
        });

        item.addedDateEditing = false;
    };

    // $scope.buildSystemLotData = function() {
    //     Projects.query({}, function(projects) {
    //         _.each(projects, function(project) {
    //              var newLots = [];

    //             _.each(project.lots, function(projLot) {
    //                 newLots.push({
    //                     number: projLot.number,
    //                     phase: projLot.phase,
    //                     active: projLot.scheduled,
    //                     date_scheduled: new Date(projLot.start_date),
    //                     date_added: new Date(projLot.start_date),
    //                     complete: projLot.complete
    //                 });
    //             });

    //             var newRecord = new SystemLots({
    //                 'trade_code': project.trade_code,
    //                 'company_code': project.company_code,
    //                 'project_id': project._id,
    //                 'lots': newLots
    //             });

    //             newRecord.$save();
    //         });
    //     });
    // };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/system-lots/public/controllers/systemLots.js